import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';

const StyledSocialShare = styled.ul`
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;

  li {
    &:not(:last-child) {
      margin-right: 1em;
    }

    a {
      color: black;
      padding: 0.5em 0.75em;
      border-radius: 5px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      font-weight: 600;
      display: flex;
    }

    img {
      width: 80%;
    }
  }
`;

export const SocialShare = ({ link, title }) => {
  link = link || document.location.href;

  return (
    <StyledSocialShare>
      <li>
        <Link href={`https://www.linkedin.com/shareArticle?url=${link}&title=${title}`}>
          <a title="Share on LinkedIn" target="_blank">
            <Image
              alt="linked-in-share-icon"
              src="/images/icons/linkedin.svg"
              width="24px"
              height="24px"
            />
          </a>
        </Link>
      </li>

      <li>
        <Link href={`https://www.facebook.com/sharer.php?href=${link}`}>
          <a title="Share on Facebook" target="_blank">
            <Image
              alt="facebook-share-icon"
              src="/images/icons/facebook.svg"
              width="24px"
              height="24px"
            />
          </a>
        </Link>
      </li>

      <li>
        <Link href={`https://www.twitter.com/share?url=${link}&text=${title}`}>
          <a title="Share on Twitter" target="_blank">
            <Image
              alt="twitter-share-icon"
              src="/images/icons/twitter.svg"
              width="24px"
              height="24px"
            />
          </a>
        </Link>
      </li>
    </StyledSocialShare>
  );
};
